import { HelperService } from 'src/app/services/helper/helper.service';
import { ModalController, NavParams } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video',
  templateUrl: './video.page.html',
  styleUrls: ['./video.page.scss'],
})
export class VideoPage implements OnInit {

  video: any;

  constructor(
    public navParams: NavParams,
    private modalController: ModalController,
    private helperService: HelperService
  ) {
    // obtiene los parametros de la data
    this.video = this.navParams.get('video');
  }

  ngOnInit() {
    if (this.video) {
      this.helperService.presentLoading();
      this.loadIframe();
      setTimeout( () => {
        this.helperService.dismissLoading();
      }, 5000);
      return;
    } else {
      this.closeModal();
    }
  }

  // retorna la url del iframe
  loadIframe() {
    const site = this.video.url;
    const frame: any = document.getElementById('iframeWrapper');
    frame.src = site;
  }

  closeModal(): void {
    this.modalController.dismiss();
  }

}
